import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';

import { WbsoHandbookPageComponent } from './core/components/header/wbso-handbook/wbso-handbook-page/wbso-handbook-page.component';
import { WbsoHandbookComponent } from './core/components/header/wbso-handbook/wbso-handbook.component';
import { HomepageComponent } from './core/components/homepage/homepage.component';
import { AuthGuardFn } from './core/services/auth-guard/auth-guard';
import { ErrorComponent } from './errors/error/error.component';
import { EmailActionComponent } from './shared/components/email-action/email-action.component';
import { UploadFileComponent } from './shared/components/upload-file/upload-file.component';
import { UsercogformComponent } from './shared/components/usercogform/usercogform.component';
import { RegisterComponent } from './core/components/register/register.component';

const routes: Routes = [
  { path: '', component: HomepageComponent },
  { path: 'homepage', component: HomepageComponent },
  { path: 'implicit/callback', component: OktaCallbackComponent },
  { path: 'wbso-handbook', component: WbsoHandbookComponent },
  { path: 'wbso-handbook-page', component: WbsoHandbookPageComponent },
  { path: 'riskmailtier2', component: EmailActionComponent },
  { path: 'usercogform', component: UsercogformComponent },
  {
    path: 'feature',
    loadChildren: () => import('./feature/feature.module').then(m => m.FeatureModule),
    canActivate: [AuthGuardFn],
  },
  {
    path: 'core',
    loadChildren: () => import('./core/core.module').then(m => m.CoreModule)
  },

  { path: 'page-not-found', component: ErrorComponent },
  {path: 'register', component: RegisterComponent},
  { path: 'upload-file', component: UploadFileComponent },
  { path: '**', redirectTo: '/page-not-found', pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
